import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormHelperText,
    InputLabel,
    Select,
    Stack,
    TextField,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import {
    ADDRESS_FIELD_LABELS,
    COUNTRIES,
    PRIORITY_COUNTRY_CODES,
} from "../../../utils/addressData";
import { CONTACT_FIELD_LABELS } from "../../../utils/contactValidation";
import MultilineTextField from "../../shared/MultilineTextField";

const SupplierFormDialog = ({
    open,
    supplier,
    fieldErrors,
    saving,
    onClose,
    onFieldChange,
    onSave,
}) => (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{supplier.id ? "Lieferant bearbeiten" : "Lieferant anlegen"}</DialogTitle>
        <DialogContent dividers>
            <Stack spacing={2}>
                <TextField
                    label="Name"
                    value={supplier.name}
                    onChange={(event) => onFieldChange("name", event.target.value)}
                    fullWidth
                    required
                    autoFocus
                    error={Boolean(fieldErrors.name)}
                    helperText={fieldErrors.name || ""}
                />
                <TextField
                    label={ADDRESS_FIELD_LABELS.street}
                    value={supplier.street}
                    onChange={(event) => onFieldChange("street", event.target.value)}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.street)}
                    helperText={fieldErrors.street || ""}
                />
                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                    <TextField
                        label={ADDRESS_FIELD_LABELS.zip}
                        value={supplier.zip}
                        onChange={(event) => onFieldChange("zip", event.target.value)}
                        fullWidth
                        required
                        error={Boolean(fieldErrors.zip)}
                        helperText={fieldErrors.zip || ""}
                    />
                    <TextField
                        label={ADDRESS_FIELD_LABELS.city}
                        value={supplier.city}
                        onChange={(event) => onFieldChange("city", event.target.value)}
                        fullWidth
                        required
                        error={Boolean(fieldErrors.city)}
                        helperText={fieldErrors.city || ""}
                    />
                </Stack>
                <FormControl fullWidth required error={Boolean(fieldErrors.country)}>
                    <InputLabel>{ADDRESS_FIELD_LABELS.country}</InputLabel>
                    <Select
                        label={ADDRESS_FIELD_LABELS.country}
                        value={supplier.country || ""}
                        onChange={(event) => onFieldChange("country", event.target.value)}
                    >
                        {PRIORITY_COUNTRY_CODES.map((code) => {
                            const entry = COUNTRIES.find((country) => country.code === code);
                            if (!entry) return null;
                            return (
                                <MenuItem key={entry.code} value={entry.code}>
                                    {entry.name}
                                </MenuItem>
                            );
                        })}
                        <MenuItem disabled>──────────</MenuItem>
                        {COUNTRIES
                            .filter((country) => !PRIORITY_COUNTRY_CODES.includes(country.code))
                            .map((country) => (
                                <MenuItem key={country.code} value={country.code}>
                                    {country.name}
                                </MenuItem>
                            ))}
                    </Select>
                    {fieldErrors.country && <FormHelperText>{fieldErrors.country}</FormHelperText>}
                </FormControl>
                <TextField
                    label={CONTACT_FIELD_LABELS.email}
                    type="email"
                    value={supplier.email}
                    onChange={(event) => onFieldChange("email", event.target.value)}
                    fullWidth
                    error={Boolean(fieldErrors.email)}
                    helperText={fieldErrors.email || ""}
                />
                <TextField
                    label={CONTACT_FIELD_LABELS.phone}
                    value={supplier.phone}
                    onChange={(event) => onFieldChange("phone", event.target.value)}
                    fullWidth
                    error={Boolean(fieldErrors.phone)}
                    helperText={fieldErrors.phone || ""}
                />
                <MultilineTextField
                    label="Notizen"
                    value={supplier.notes}
                    onChange={(event) => onFieldChange("notes", event.target.value)}
                    fullWidth
                    error={Boolean(fieldErrors.notes)}
                    helperText={fieldErrors.notes || ""}
                />
            </Stack>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} disabled={saving}>
                Abbrechen
            </Button>
            <Button
                onClick={onSave}
                disabled={saving}
                variant="contained"
                sx={{ backgroundColor: "orange", color: "#000", fontWeight: 700, "&:hover": { backgroundColor: "#ff9e1a" } }}
            >
                {saving ? "Speichere…" : "Speichern"}
            </Button>
        </DialogActions>
    </Dialog>
);

export default SupplierFormDialog;
